module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('subscriber-info', {
    attrs: {
      "subscriber-id": _vm.subscriberId
    }
  }), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "value": "1",
      "stretch": ""
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "小程序信息",
      "name": "1"
    }
  }, [_c('subscriber-ma', {
    attrs: {
      "subscriber-id": _vm.subscriberId
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "收货地址",
      "name": "2"
    }
  }, [_c('subscriber-contact', {
    attrs: {
      "subscriber-id": _vm.subscriberId
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "优惠券",
      "name": "3"
    }
  }, [_c('subscriber-coupon', {
    attrs: {
      "subscriber-id": _vm.subscriberId
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "订单",
      "name": "4"
    }
  }, [_c('subscriber-order', {
    attrs: {
      "subscriber-id": _vm.subscriberId
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "活动记录",
      "name": "5"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-f3859cca","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/biz/subscriber/components/detail.vue
// module id = 1761
// module chunks = 0